import { UserRoles } from 'types';

export const allRoles = [
	UserRoles.SUPER_USER,
	UserRoles.GROUP_MANAGER,
	UserRoles.CLIENT_MANAGER,
	UserRoles.RESTAURANT_MANAGER,
	UserRoles.TECHNICAL,
	UserRoles.WAITER,
	UserRoles.RKL_SUPPORT_MANAGER,
	UserRoles.NON_EXISTENT_ROLE,
];
